import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'tracking-codes-customers' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
